module.exports = __webpack_public_path__ + "static/media/04.37f07ac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/img/04.jpg
// module id = 606
// module chunks = 20